import styled from '@emotion/styled'
import Box from '@mui/material/Box'

import { WTPayload } from '@js/WTPayload'

import { HouseSectionsNavigation } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/HouseSectionsNavigation'
import { DetailSection } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/DetailsSection/DetailSection'
import { FloorPlansSection } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/FloorPlansSection/FloorPlansSection'
import { OverviewSection } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/OverviewSection/OverviewSection'
import { PriceSection } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/PriceSection/PriceSection'
import { SimilarHouses } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/SimilarHouses'
import { SimilarHousesSectionLoading } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/SimilarHouses/SimilarHousesSectionPlaceholder'
import { VendorDetailsSection } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/VendorDetailsSection'
import { ClientOnly } from '@f-fertighaus/components/ClientOnly/ClientOnly'

export const COMMON_TAB_WT_PAYLOAD_PROPS = ({
  wtLabel,
  label
}: {
  wtLabel: string
  label: string
}): WTPayload => ({
  category: 'CTA-button',
  action: 'click',
  location: 'sub-menu',
  values: [{ type: 'text', value: label }],
  label: wtLabel
})

export const HouseSections = () => {
  return (
    <SectionsWrapper>
      <HouseSectionsNavigation />
      <OverviewSection />
      <FloorPlansSection />
      <DetailSection />
      <PriceSection />
      <VendorDetailsSection />
      <ClientOnly fallback={<SimilarHousesSectionLoading />}>
        <SimilarHouses />
      </ClientOnly>
    </SectionsWrapper>
  )
}

const SectionsWrapper = styled(Box)`
  width: 100%;
  grid-area: main-content;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: ${({ theme }) => theme.spacing(8)};
  }
`
